import React, { useEffect, useState } from "react";

const GroupCheckBox = (props) => {
  const { form, field } = props;
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    if (field.value) {
      setSelected(field.value);
      form.setFieldValue(field.name, field.value);
    } else {
      setSelected([]);
      form.setFieldValue(field.name, []);
    }
  }, [field.value]);

  const handleSingleCheck = (e) => {
    let selectedItems = [];
    if (e.target.checked) {
      selectedItems = [...selected, e.target.value];
    } else {
      selectedItems = selected.filter((item) => item != e.target.value);
    }
    if (selectedItems && selectedItems.includes("*")) {
      selectedItems = ["*"];
    }
    setSelected(selectedItems);
    form.setFieldValue(field.name, selectedItems);
  };

  const handleGroupCheck = (checked, childs) => {
    let items = childs && childs.length > 0 && childs.map((item) => item.value);
    let selectedItems = [];
    if (checked) {
      selectedItems = [
        ...selected.filter((item) => !items.includes(item)),
        ...items,
      ];
    } else {
      selectedItems = selected.filter((item) => !items.includes(item));
    }
    if (selectedItems && selectedItems.includes("*")) {
      selectedItems = ["*"];
    }
    setSelected(selectedItems);

    form.setFieldValue(field.name, selectedItems);
  };

  const isCheckedGroup = (childs) => {
    let items = childs && childs.length > 0 && childs.map((item) => item.value);
    return selected.some((r) => items.includes(r));
  };

  return (
    <>
      {props.options &&
        props.options.length > 0 &&
        props.options.map((item) => (
          <div className="border-dashed border-2 rounded p-2 ">
            <div className="form-check mr-2 mt-2 sm:mt-0  ">
              <input
                disabled={
                  selected && selected.includes("*") && item.value !== "admin"
                }
                id={`checkbox${item.value}`}
                className="form-check-input"
                type="checkbox"
                checked={
                  isCheckedGroup(item.childs) ||
                  (selected && selected.includes("*"))
                }
                onChange={(e) => {
                  handleGroupCheck(e.target.checked, item.childs);
                }}
              />
              <label
                className="form-check-label mr-2 text-white"
                htmlFor={`checkbox${item.value}`}
              >
                <h5 className="text-white">{item.label}</h5>
              </label>
            </div>
            <hr className="border-dashed my-2" />
            <div className="flex flex-col sm:flex-row mt-2 flex-wrap mr-2">
              {item.childs &&
                item.childs.length > 0 &&
                item.childs.map((item) => (
                  <div className="form-check mr-2">
                    <input
                      disabled={
                        selected && selected.includes("*") && item.value !== "*"
                      }
                      id={`sub-checkbox${item.value}`}
                      className="form-check-input"
                      type="checkbox"
                      checked={
                        selected.includes(item.value) ||
                        (selected &&
                          selected.includes("*") &&
                          item.value !== "admin")
                      }
                      value={item.value}
                      onChange={handleSingleCheck}
                    />
                    <label
                      className=" mr-2 text-white"
                      htmlFor={`sub-checkbox${item.value}`}
                    >
                      {item.label}
                    </label>
                  </div>
                ))}
            </div>
          </div>
        ))}
    </>
  );
};
export default GroupCheckBox;
